import { TOOLTIPS } from "../constants/messages";

/**
 * Get tooltip text by key
 * @param key - The tooltip key (e.g., "navbar.button.collapse", "navbar.button.expand")
 * @returns The tooltip text or empty string if not found
 */
export function getTooltip(key: string): string {
  return TOOLTIPS[key] || "";
}
